import AltMedocInfo from "./AltMedocInfo";

export default class ServiceInfo {
    remainingQuantity?: number;
    price: number;
    discountRate: number;
    alternatives: AltMedocInfo[];

    constructor(price: number, discountRate: number, remainingQuantity?: number) {
        this.remainingQuantity = remainingQuantity;
        this.price = price;
        this.discountRate = discountRate;
        this.alternatives = [];
    }
}